export default __webpack_public_path__ + "static/media/work_together.acf3730f.svg";